exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.trait-list {\n        > ul {\n            list-style: none;\n        }\n    }*/", ""]);

// exports
